import { render, staticRenderFns } from "./HeaderXs.vue?vue&type=template&id=ff2c9d88&scoped=true&"
import script from "./HeaderXs.vue?vue&type=script&lang=js&"
export * from "./HeaderXs.vue?vue&type=script&lang=js&"
import style0 from "./HeaderXs.vue?vue&type=style&index=0&id=ff2c9d88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2c9d88",
  null
  
)

export default component.exports